import { Component, OnInit, Input, ViewChild, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbPagination } from "@ng-bootstrap/ng-bootstrap/pagination";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { DatetimePipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-alerts",
	templateUrl: "./mech-alerts.component.html",
	styleUrls: ["./mech-alerts.component.scss"],
	imports: [ActionButtonComponent, NgbPagination, FormsModule, DatetimePipe]
})
export class MechAlertsComponent implements OnInit {
	api = inject(ApiService);
	private modalService = inject(NgbModal);

	@ViewChild("ackNoteModal") public ackNoteModal: any;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public pageLogs: APIResults.Alert[];
	public pageLoading = false;

	public totalAlerts = 0;
	public alertCurrentPage = 1;
	public alertItemsPerPage = 15;

	public acknowledgingAlert: number;
	public acknowledgeModalVisible = false;
	public acknowledgingNote: string;

	async ngOnInit() {
		await this.alertUpdatePage();
	}

	async alertUpdatePage() {
		try {
			this.pageLoading = true;
			const result = await this.api.GetAlerts(this.asset.asset_id, this.alertItemsPerPage * (this.alertCurrentPage - 1), this.alertItemsPerPage);
			const flattened = DvsUtilities.FlattenComponents(this.components);
			for (const row of result.rows) {
				if (row.component_key) {
					const comp = flattened.find(item => item.id === row.component_key);
					if (comp) {
						row.component_name = comp.name + " (" + comp.id + ")";
					}
				}
			}
			this.totalAlerts = result.count;
			this.pageLogs = result.rows;
		} finally {
			this.pageLoading = false;
		}
	}

	async PromptAcknowledge(id: number) {
		this.acknowledgingAlert = id;
		this.modalService.open(this.ackNoteModal);
	}

	async AcknowledgeAlert() {
		await this.api.UpdateAlertAck(this.asset.asset_id, this.acknowledgingAlert, this.acknowledgingNote, true);
		this.asset.alertcount--;
		await this.alertUpdatePage();
		this.acknowledgingAlert = undefined;
		this.acknowledgingNote = undefined;
		this.modalService.dismissAll();
	}

	async UnacknowledgeAlert(id: number) {
		await this.api.UpdateAlertAck(this.asset.asset_id, id, null, false);
		this.asset.alertcount++;
		await this.alertUpdatePage();
	}

	async DeleteAlert(id: number) {
		await this.api.DeleteAlert(this.asset.asset_id, id);
		this.asset.alertcount--;
		await this.alertUpdatePage();
	}

	async ExportAlerts() {
		await this.api.ExportAlerts(this.asset.asset_name + "_" + Moment().format("YYYY-MM-DD HHmmss") + "_Alerts.csv", this.asset.asset_id);
	}

	async AcknowledgeAll() {
		await this.api.AcknowledgeAllAlerts(this.asset.asset_id);
		this.asset.alertcount = 0;
		await this.alertUpdatePage();
	}
}
